var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[_c('div',[_c('van-uploader',{attrs:{"after-read":_vm.afterRead,"accept":_vm.accept,"max-size":2000 * 1024,"multiple":"","max-count":1},on:{"oversize":_vm.onOversize},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }